export default __webpack_public_path__ + "static/media/limit_70.297f2269.svg";